import { mapStoreGetters, storeTypes } from '/@/vuex/helpers'

export default {
  computed: {
    ...mapStoreGetters(storeTypes.SETTINGS, ['state.file', 'state.paths.subscription', 'state.frequencyDivider']),
  },
}
